import React from 'react';
import { Section } from './Section';
import { images } from '../data/checkout';
export function Author() {
  return <Section tone="white" cta="I want Dr. Wells' clinical blueprint" ctaNote="One-Time Payment of $27 USD · Instant Download · 7-Day Guarantee" data-id="element-20" data-mp="oil3jgv4qetg">
      <div className="grid gap-8 md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] md:items-start md:gap-12" data-id="element-21" data-mp="ergoyi9d8vz5">
        <figure className="mx-auto w-full max-w-sm md:sticky md:top-8" data-id="element-22" data-mp="12h1b1a0tg9cn">
          <img src={images.author} alt="Dr. Henry Wells" className="aspect-[4/5] w-full rounded-3xl object-cover object-top shadow-card" loading="lazy" data-id="element-23" data-mp="12fq26vsikbeo" />
          <figcaption className="mt-3 text-center" data-id="element-24" data-mp="xi7t95ehxw6o">
            <span className="block font-serif text-xl font-bold text-ink" data-id="element-25" data-mp="xgwrfb4m2yi7">Dr. Henry Wells</span>
            <span className="text-sm text-muted" data-id="element-26" data-mp="3d82hzh390wfd">Creator of Obesity Clinical Blueprint™</span>
          </figcaption>
        </figure>

        <div data-id="element-27" data-mp="3i6cfhycg4945">
          <p className="text-sm font-bold uppercase tracking-[0.14em] text-brand" data-id="element-28" data-mp="1tyaghhoa85xb">Created by Dr. Henry Wells</p>
          <h2 className="mt-2 font-serif text-[32px] font-bold leading-[1.12] text-ink sm:text-4xl" data-id="element-29" data-mp="1p00ikzb6ar80">
            Why I created Obesity Clinical Blueprint™
          </h2>
          <div className="mt-6 space-y-5 text-[17px] leading-relaxed text-muted" data-id="element-30" data-mp="22wvy9alxjgx1">
            <p data-id="element-31" data-mp="1y29v1uq04uo1">
              When working with obesity-related clinical information, one challenge becomes clear very quickly: the
              subject involves far more than a single measurement or treatment decision.
            </p>
            <p data-id="element-32" data-mp="2lphwu2o81llb">
              Patient history, existing conditions, treatment preferences, metabolic health, individual goals, and
              ongoing follow-up may all need to be considered — and organizing it for practical use is challenging when
              time is limited.
            </p>
            <p data-id="element-33" data-mp="2qp2vsd3e5ty1">
              I recognized that <strong className="text-ink" data-id="element-34" data-mp="2qq5n2m4mlyeh">accessing information and organizing it for a consultation are two different tasks.</strong>{' '}
              A clinician may have access to excellent guidelines and still benefit from a clearer way to structure the
              information relevant to a particular patient.
            </p>
            <p data-id="element-35" data-mp="1xaa0xit38ylb">
              So I brought the major stages of adult obesity care together in a structured collection that can be
              reviewed, printed, and navigated without creating an entirely new organizational system.
            </p>
            <p data-id="element-36" data-mp="2bzy30m93g1a3">
              My intention was not to replace professional expertise or dictate decisions for every patient, but to help
              healthcare professionals approach consultations with a clearer structure.
            </p>
            <p className="font-serif text-xl font-bold italic leading-snug text-ink" data-id="element-37" data-mp="2kzl57a9ndb47">
              Because a well-organized clinical workflow should support your judgment, not replace it.
            </p>
            <p className="font-semibold text-ink" data-id="element-38" data-mp="qpr0nsh29i9n">— Dr. Henry Wells</p>
          </div>
        </div>
      </div>
    </Section>;
}